<div class="page-wrapper pt-5">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="actions-row">
                    <mat-form-field class="search" appearance="standard">
                        <mat-label class="filter-placeholder">{{'SEARCH' | translate}}</mat-label>
                        <input matInput class="filter-input" (keyup)="applyFilter($event)" #input>
                        <div class="search-icon">
                            <fa-icon [icon]="faSearch"></fa-icon>
                        </div>
                    </mat-form-field>
                    <div class="d-flex justify-content-center mb-4">
                        <mat-button-toggle-group #toggleGroup1="matButtonToggleGroup" (change)="tabChange(toggleGroup1.value)" name="fontStyle" aria-label="Requests" [value]="tab">
                            <mat-button-toggle value="pending">{{'REQUEST.PENDING' | translate}}</mat-button-toggle>
                            <mat-button-toggle value="provided">{{'REQUEST.PROVISIONED' | translate}}</mat-button-toggle>
                            <mat-button-toggle value="history">{{'REQUEST.HISTORY' | translate}}</mat-button-toggle>
                        </mat-button-toggle-group>
                    </div>
                </div>
                <div class="contents-table mat-elevation-z4">
                    <!-- Pending Request Table -->
                    <table mat-table matSort [dataSource]="pendingDataSource" class="w-100" *ngIf="tab === 'pending'">
                        <caption>Request info</caption>
                        <!-- Submission Column -->
                        <ng-container matColumnDef="lastApproval">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef mat-sort-header="submittedAt" sortActionDescription="Sort by Submission"> {{'PENDING_REQUEST_INFO.SUBMISSION' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.submittedAt}} </td>
                        </ng-container>

                        <!-- Type Column -->
                        <ng-container matColumnDef="type">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef mat-sort-header="resourceName" sortActionDescription="Sort by Type"> {{'PENDING_REQUEST_INFO.TYPE' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.resourceName}} </td>
                        </ng-container>

                        <!-- Request ID Column -->
                        <ng-container matColumnDef="id">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef mat-sort-header sortActionDescription="Sort by ID"> {{'PENDING_REQUEST_INFO.REQ_ID' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.id}} </td>
                        </ng-container>

                        <!-- Tag Column -->
                        <ng-container matColumnDef="tag">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Tag"> {{'PENDING_REQUEST_INFO.TAG' | translate}}
                            </th>
                            <td class="tags-cell" mat-cell *matCellDef="let element">
                                <app-tags-list [tags]="element.tags"></app-tags-list>
                            </td>
                        </ng-container>

                        <!-- Assignee Column -->
                        <ng-container matColumnDef="assignee">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Assignee"> {{'PENDING_REQUEST_INFO.ASSIGNEE' | translate}}
                            </th>
                            <td mat-cell *matCellDef="let element"> {{element.assignee}} </td>
                        </ng-container>

                        <!-- Status Column -->
                        <ng-container matColumnDef="status">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef>
                                {{'PENDING_REQUEST_INFO.STATUS' | translate}} </th>
                            <td mat-cell *matCellDef="let element">
                                <app-status-indicator [status]="element.status"></app-status-indicator>
                            </td>
                        </ng-container>

                        <!-- Details Column -->
                        <ng-container matColumnDef="details">
                            <th mat-header-cell class="text-center user-select-none font-15" *matHeaderCellDef>
                                {{'PENDING_REQUEST_INFO.DETAILS' | translate}} </th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <fa-icon (click)="infoPendingModal(element)" class="cursor-pointer info-btn" [icon]="faCircleInfo"></fa-icon>
                            </td>
                        </ng-container>

                        <!-- Delete Column -->
                        <ng-container matColumnDef="delete">
                            <th mat-header-cell class="text-center user-select-none font-15" *matHeaderCellDef>
                                {{'PENDING_REQUEST_INFO.DELETE' | translate}} </th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <fa-icon (click)="withdrawModal(element)" class="cursor-pointer withdraw-btn" *ngIf="element.status[element.status.length-1].status == ''" [icon]="faTrash"></fa-icon>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsPending; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsPending;"></tr>

                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">{{'NO_RESULT' | translate}}</td>
                        </tr>
                    </table>

                    <!-- Provisioned Request Table -->
                    <table mat-table matSort [dataSource]="providedDataSource" class="w-100" *ngIf="tab === 'provided'">
                        <caption>Request info</caption>
                        <!-- Submission Column -->
                        <ng-container matColumnDef="lastApproval">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef mat-sort-header="approvalAt" sortActionDescription="Sort by Last Approval"> {{'PROVISIONED_REQUEST_INFO.APPROVAL' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.approvalAt}} </td>
                        </ng-container>

                        <!-- Type Column -->
                        <ng-container matColumnDef="type">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef mat-sort-header="resourceName" sortActionDescription="Sort by Type"> {{'PROVISIONED_REQUEST_INFO.TYPE' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.resourceName}} </td>
                        </ng-container>

                        <!-- Request ID Column -->
                        <ng-container matColumnDef="id">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef mat-sort-header="id" sortActionDescription="Sort by ID"> {{'PROVISIONED_REQUEST_INFO.REQ_ID' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.id}} </td>
                        </ng-container>

                        <!-- Tag Column -->
                        <ng-container matColumnDef="tag">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Tag"> {{'PROVISIONED_REQUEST_INFO.TAG' | translate}}
                            </th>
                            <td class="tags-cell" mat-cell *matCellDef="let element">
                                <app-tags-list [tags]="element.tags"></app-tags-list>
                            </td>
                        </ng-container>

                        <!-- Expiration Column -->
                        <ng-container matColumnDef="expiration">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef mat-sort-header="expirationDate" sortActionDescription="Sort by Expiration"> {{'PROVISIONED_REQUEST_INFO.EXPIRATION' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.expirationDate}} </td>
                        </ng-container>

                        <!-- Details Column -->
                        <ng-container matColumnDef="details">
                            <th mat-header-cell class="text-center user-select-none font-15" *matHeaderCellDef> {{'PROVISIONED_REQUEST_INFO.DETAILS' | translate}}
                            </th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <fa-icon (click)="infoProvidedModal(element)" class="cursor-pointer info-btn" [icon]="faCircleInfo"></fa-icon>
                            </td>
                        </ng-container>

                        <!-- Actions Column -->
                        <ng-container matColumnDef="renew">
                            <th mat-header-cell class="text-center user-select-none font-15" *matHeaderCellDef> {{'PROVISIONED_REQUEST_INFO.ACTIONS' | translate}}
                            </th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <fa-icon (click)="renewModal(element)" class="cursor-pointer renew-btn me-3" [icon]="faRotateRight" *ngIf="element.renewId"></fa-icon>
                                <fa-icon (click)="deprovisioning(element)" class="cursor-pointer withdraw-btn" [icon]="faTrash"></fa-icon>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsProvided; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsProvided;"></tr>

                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">{{'NO_RESULT' | translate}}</td>
                        </tr>
                    </table>

                    <!-- History Request Table -->
                    <table mat-table matSort [dataSource]="historyDataSource" class="w-100" *ngIf="tab === 'history'">
                        <caption>Request info</caption>
                        <!-- Submission Column -->
                        <ng-container matColumnDef="submittedAt">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef mat-sort-header="submittedAt" sortActionDescription="Sort by Submission"> {{'HISTORY_REQUEST_INFO.SUBMISSION' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.submittedAt}} </td>
                        </ng-container>

                        <!-- Resolution Column -->
                        <ng-container matColumnDef="resolved">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef mat-sort-header="resolvedAt" sortActionDescription="Sort by Resolution"> {{'HISTORY_REQUEST_INFO.RESOLUTION' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.resolvedAt}} </td>
                        </ng-container>

                        <!-- Type Column -->
                        <ng-container matColumnDef="type">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef mat-sort-header="resourceName" sortActionDescription="Sort by Type"> {{'HISTORY_REQUEST_INFO.TYPE' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.resourceName}} </td>
                        </ng-container>

                        <!-- Request ID Column -->
                        <ng-container matColumnDef="id">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef mat-sort-header="id" sortActionDescription="Sort by ID"> {{'HISTORY_REQUEST_INFO.REQ_ID' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.id}} </td>
                        </ng-container>

                        <!-- Tag Column -->
                        <ng-container matColumnDef="tag">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Tag"> {{'HISTORY_REQUEST_INFO.TAG' | translate}}
                            </th>
                            <td class="tags-cell" mat-cell *matCellDef="let element">
                                <app-tags-list [tags]="element.tags"></app-tags-list>
                            </td>
                        </ng-container>

                        <!-- Status Column -->
                        <ng-container matColumnDef="status">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef> {{'HISTORY_REQUEST_INFO.STATUS' | translate}} </th>
                            <td mat-cell *matCellDef="let element">
                                <app-status-indicator [status]="element.status"></app-status-indicator>
                            </td>
                        </ng-container>

                        <!-- Details Column -->
                        <ng-container matColumnDef="details">
                            <th mat-header-cell class="text-center user-select-none font-15" *matHeaderCellDef> {{'HISTORY_REQUEST_INFO.DETAILS' | translate}}
                            </th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <fa-icon (click)="infoHistoryModal(element)" class="cursor-pointer info-btn" [icon]="faCircleInfo"></fa-icon>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsHistory; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsHistory;"></tr>

                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">{{'NO_RESULT' | translate}}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 d-flex justify-content-center my-4">
                <button mat-flat-button class="btn-action primary new-request-btn" (click)="newReqModal()">{{'NEW_REQUEST' | translate}}</button>
            </div>
        </div>
    </div>
</div>